<template>
  <v-dialog width="500" v-model="showUNClassForm">
    <v-card>
      <v-card-title class="secondary white--text">
        <span> {{ editMode ? "Update" : "Add" }} UN Class </span>

        <v-spacer></v-spacer>

        <v-btn icon @click="resetForm(), (showUNClassForm = false)">
          <v-icon class="white--text">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-2">
        <v-form ref="unClassForm" v-if="showUNClassForm" v-model="isValid">
          <v-row class="my-0">
            <v-col cols="12" class="Form-Columns">
              <InputField
                type="text"
                label="UN No. *"
                required
                :rules="[(val) => !!val || 'UN No is Required!']"
                hide-details="auto"
                v-model="formDetails.un_no"
                :error-messages="formErrors.un_no"
                @input="delete formErrors.un_no"
              />
            </v-col>

            <v-col cols="12" class="Form-Columns">
              <InputField
                type="text"
                label="UN Class *"
                required
                :rules="[(val) => !!val || 'UN Class is Required!']"
                hide-details="auto"
                v-model="formDetails.un_class"
                :error-messages="formErrors.un_class"
                @input="delete formErrors.un_class"
              />
            </v-col>


            <v-col cols="12" class="Form-Columns">
              <InputField
                type="text"
                label="Description"
                hide-details="auto"
                v-model="formDetails.un_description"
                :error-messages="formErrors.un_description"
                @input="delete formErrors.un_description"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="justify-end">
        <v-btn
          color="primary"
          depressed
          :disabled="!isValid"
          @click="submitForm"
        >
          Submit
        </v-btn>

        <v-btn
          class="ml-2"
          color="secondary"
          v-if="!editMode"
          depressed
          @click="resetForm"
        >
          Reset
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/FormBaseComponents/InputField.vue";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";
import SelectField from "@/components/FormBaseComponents/SelectField.vue";

export default {
  components: {
    InputField,
    SelectField,
    MultiSelect,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    editUNClassID: {
      type: [Number, null],
      default: null,
    },
  },
  watch: {
    value(val) {
      if (val) {
        if (this.editMode) {
          this.getUNClassObject(this.editUNClassID);
        }
      } else {
        this.resetForm();
      }
    },
  },
  computed: {
    showUNClassForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      formDetails: {},
      formErrors: {},
      isTextInput: false,
      isValid: true,
    };
  },
  methods: {
    submitForm() {
      this.$bus.$emit("showLoader", true);
      if (!this.editMode) {
        this.formDetails = {
          ...this.formDetails,
        };
        this.$api.unClass
          .addUNClass(this.formDetails)
          .then((res) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "UN Class added successfully!",
              color: "success",
            });
            this.resetForm();
            this.showUNClassForm = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Couldn't add UN Class!",
              color: "error",
            });
            this.formErrors = err.data;
          });
      } else {
        this.$api.unClass
          .updateUNClass({ id: this.formDetails.id, data: this.formDetails })
          .then((res) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "UN Class updated successfully!",
              color: "success",
            });
            this.resetForm();
            this.showUNClassForm = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Couldn't update UN Class!",
              color: "error",
            });
            this.formErrors = err.data;
          });
      }
    },

    resetForm() {
      if (this.$refs.unClassForm) {
        this.$refs.unClassForm.reset();
      }
      this.formDetails = {};
    },

    getUNClassObject(id) {
      this.$bus.$emit("showLoader", true);
      this.$api.unClass
        .getUNClassObject(id)
        .then((res) => {
          this.$bus.$emit("showLoader", false);
          this.formDetails = res.data;
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
  },
};
</script>
